import React from 'react';
import {
    FETCH_SLA_REQUEST,
    FETCH_SLA_REQUEST_SUCCESS,
    FETCH_SLA_REQUEST_FAILER,
    CREATE_SLA_REQUEST,
    CREATE_SLA_REQUEST_SUCCESS,
    CREATE_SLA_REQUEST_FAILER
} from './SlaActionTypes';
import { IAction } from './ISlaAction';

interface IInitialState {
    loading: boolean,
    SLAData: any,
    error: string
};

const initialState: IInitialState = {
    loading: false,
    SLAData: [],
    error: ""
};
const SlaReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case FETCH_SLA_REQUEST:
            return {
                ...state,
                loading: true,
                error: ""
            };
            break;
        case FETCH_SLA_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                SLAData: action.payload
            };
            break;
        case FETCH_SLA_REQUEST_FAILER:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
            break;

            case CREATE_SLA_REQUEST:
            return {
                ...state,
                loading: true,
                error: ""
            };
            break;
        case CREATE_SLA_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                // SLAData: action.payload
            };
            break;
        case CREATE_SLA_REQUEST_FAILER:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
            break;
        default:
            return { ...state }
            break;
    }
}

export default SlaReducer;